import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private readonly defaultViewMode = true; // Default to Grid View (true)
  private viewModeSubject = new BehaviorSubject<boolean>(
      localStorage.getItem('viewMode') ? localStorage.getItem('viewMode') === 'true' : this.defaultViewMode
  );
  viewMode$ = this.viewModeSubject.asObservable();

  constructor() { }
  // local-storage.service.ts

  public setValue(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  public getValue(key: string): any {
    const value = localStorage.getItem(key)
    return value ? JSON.parse(value) : null;
  }

  public removeValue(key: string): void {
    localStorage.removeItem(key);
  }
  public deleteAll():any{
    const cachedQrCode = localStorage.getItem('randomQrCode');
    localStorage.clear();
    if (cachedQrCode !== null) {
      localStorage.setItem('randomQrCode', cachedQrCode);
    }
  }

  setViewMode(isGridView: boolean) {
    this.viewModeSubject.next(isGridView);
    localStorage.setItem('viewMode', String(isGridView));
  }
}

